// Mock data for tickets
export const mockTickets = [
    {
        id: "TKT-001",
        title: "Water Leakage in Bathroom",
        description: "There's a water leak from the ceiling in the bathroom. It's causing damage to the floor.",
        category: "Plumbing",
        priority: "High",
        status: "Open",
        createdAt: "2025-05-01T09:30:00Z",
        updatedAt: "2025-05-01T15:45:00Z",
        tenant: {
            id: "TNT-101",
            name: "John Smith",
            email: "john.smith@example.com",
            phone: "+1234567890",
            unit: "Apt 304"
        },
        property: {
            id: "PROP-001",
            name: "Sunshine Apartments",
            address: "123 Main Street, Cityville"
        },
        assignedTo: null,
        scheduledDate: null,
        estimatedCost: null,
        attachments: [],
        comments: [
            {
                id: "CMT-001",
                text: "We'll send a plumber tomorrow morning between 9-11am.",
                author: "Admin",
                authorRole: "Property Manager",
                timestamp: "2025-05-01T15:45:00Z",
                isInternal: false
            }
        ]
    },
    {
        id: "TKT-002",
        title: "Air Conditioning Not Working",
        description: "The AC unit in the living room isn't cooling properly. It makes a strange noise when turned on.",
        category: "HVAC",
        priority: "Medium",
        status: "In Progress",
        createdAt: "2025-05-03T14:20:00Z",
        updatedAt: "2025-05-04T10:15:00Z",
        tenant: {
            id: "TNT-102",
            name: "Emily Johnson",
            email: "emily.j@example.com",
            phone: "+1987654321",
            unit: "Apt 201"
        },
        property: {
            id: "PROP-001",
            name: "Sunshine Apartments",
            address: "123 Main Street, Cityville"
        },
        assignedTo: {
            id: "STAFF-002",
            name: "Mike Technician",
            role: "Maintenance"
        },
        scheduledDate: "2025-05-06T13:00:00Z",
        estimatedCost: 150,
        attachments: [
            {
                id: "ATT-001",
                filename: "ac_unit_photo.jpg",
                uploadedBy: "TNT-102",
                uploadedAt: "2025-05-03T14:22:00Z"
            }
        ],
        comments: [
            {
                id: "CMT-002",
                text: "Technician has been assigned. They'll contact you to schedule a visit.",
                author: "Admin",
                authorRole: "Property Manager",
                timestamp: "2025-05-04T10:15:00Z",
                isInternal: false
            },
            {
                id: "CMT-003",
                text: "Let's try to fix this ASAP, it's getting warmer outside.",
                author: "Sarah Manager",
                authorRole: "Property Manager",
                timestamp: "2025-05-04T11:30:00Z",
                isInternal: true
            }
        ]
    },
    {
        id: "TKT-003",
        title: "Lost Apartment Key",
        description: "I lost my apartment key and need a replacement as soon as possible.",
        category: "Security",
        priority: "High",
        status: "Resolved",
        createdAt: "2025-05-02T11:00:00Z",
        updatedAt: "2025-05-02T16:30:00Z",
        tenant: {
            id: "TNT-103",
            name: "Robert Chen",
            email: "robert.c@example.com",
            phone: "+1122334455",
            unit: "Apt 105"
        },
        property: {
            id: "PROP-002",
            name: "Parkview Residences",
            address: "456 Park Avenue, Townsville"
        },
        assignedTo: {
            id: "STAFF-001",
            name: "Sarah Manager",
            role: "Property Manager"
        },
        scheduledDate: "2025-05-02T14:00:00Z",
        estimatedCost: 25,
        attachments: [],
        comments: [
            {
                id: "CMT-004",
                text: "You can pick up a new key from the management office. Please bring ID.",
                author: "Sarah Manager",
                authorRole: "Property Manager",
                timestamp: "2025-05-02T12:45:00Z",
                isInternal: false
            },
            {
                id: "CMT-005",
                text: "Thank you, I've collected the new key.",
                author: "Robert Chen",
                authorRole: "Tenant",
                timestamp: "2025-05-02T16:30:00Z",
                isInternal: false
            },
            {
                id: "CMT-006",
                text: "Remember to charge the $25 replacement fee.",
                author: "Admin",
                authorRole: "System",
                timestamp: "2025-05-02T17:00:00Z",
                isInternal: true
            }
        ]
    },
    {
        id: "TKT-004",
        title: "Noisy Neighbors",
        description: "The neighbors in unit 304 are playing loud music late at night. This has been ongoing for a week.",
        category: "Noise Complaint",
        priority: "Medium",
        status: "Open",
        createdAt: "2025-05-04T23:15:00Z",
        updatedAt: "2025-05-04T23:15:00Z",
        tenant: {
            id: "TNT-104",
            name: "Alice Wong",
            email: "alice.w@example.com",
            phone: "+1567891234",
            unit: "Apt 302"
        },
        property: {
            id: "PROP-001",
            name: "Sunshine Apartments",
            address: "123 Main Street, Cityville"
        },
        assignedTo: null,
        scheduledDate: null,
        estimatedCost: null,
        attachments: [
            {
                id: "ATT-002",
                filename: "noise_recording.mp3",
                uploadedBy: "TNT-104",
                uploadedAt: "2025-05-04T23:17:00Z"
            }
        ],
        comments: []
    },
    {
        id: "TKT-005",
        title: "Broken Kitchen Sink",
        description: "The kitchen sink is clogged and water doesn't drain properly.",
        category: "Plumbing",
        priority: "Medium",
        status: "Closed",
        createdAt: "2025-04-28T08:45:00Z",
        updatedAt: "2025-04-29T14:20:00Z",
        tenant: {
            id: "TNT-105",
            name: "David Miller",
            email: "david.m@example.com",
            phone: "+1654789321",
            unit: "Apt 410"
        },
        property: {
            id: "PROP-002",
            name: "Parkview Residences",
            address: "456 Park Avenue, Townsville"
        },
        assignedTo: {
            id: "STAFF-003",
            name: "Tom Plumber",
            role: "Contractor"
        },
        scheduledDate: "2025-04-29T10:00:00Z",
        estimatedCost: 75,
        actualCost: 85,
        attachments: [],
        comments: [
            {
                id: "CMT-007",
                text: "Plumber visited and fixed the issue. Please let us know if you face any more problems.",
                author: "Sarah Manager",
                authorRole: "Property Manager",
                timestamp: "2025-04-29T14:20:00Z",
                isInternal: false
            },
            {
                id: "CMT-008",
                text: "Had to replace a part which cost extra $10, total $85.",
                author: "Tom Plumber",
                authorRole: "Contractor",
                timestamp: "2025-04-29T13:45:00Z",
                isInternal: true
            }
        ]
    },
    {
        id: "TKT-006",
        title: "Bathroom Door Won't Lock",
        description: "The bathroom door lock is broken and won't secure properly.",
        category: "Carpentry",
        priority: "Low",
        status: "Scheduled",
        createdAt: "2025-05-03T16:20:00Z",
        updatedAt: "2025-05-04T09:10:00Z",
        tenant: {
            id: "TNT-106",
            name: "Lisa Garcia",
            email: "lisa.g@example.com",
            phone: "+1789456123",
            unit: "Apt 207"
        },
        property: {
            id: "PROP-001",
            name: "Sunshine Apartments",
            address: "123 Main Street, Cityville"
        },
        assignedTo: {
            id: "STAFF-004",
            name: "Carlos Carpenter",
            role: "Maintenance"
        },
        scheduledDate: "2025-05-07T15:00:00Z",
        estimatedCost: 45,
        attachments: [],
        comments: [
            {
                id: "CMT-009",
                text: "We've scheduled a maintenance visit for May 7th between 3-5pm.",
                author: "Admin",
                authorRole: "Property Manager",
                timestamp: "2025-05-04T09:10:00Z",
                isInternal: false
            }
        ]
    },
    {
        id: "TKT-007",
        title: "Refrigerator Not Cooling",
        description: "The refrigerator isn't cooling properly. Food is spoiling quickly.",
        category: "Appliance",
        priority: "High",
        status: "In Progress",
        createdAt: "2025-05-05T07:45:00Z",
        updatedAt: "2025-05-05T10:20:00Z",
        tenant: {
            id: "TNT-107",
            name: "Michael Brown",
            email: "michael.b@example.com",
            phone: "+1321654987",
            unit: "Apt 319"
        },
        property: {
            id: "PROP-001",
            name: "Sunshine Apartments",
            address: "123 Main Street, Cityville"
        },
        assignedTo: {
            id: "STAFF-005",
            name: "Elena Technician",
            role: "Maintenance"
        },
        scheduledDate: "2025-05-05T14:00:00Z",
        estimatedCost: 200,
        attachments: [
            {
                id: "ATT-003",
                filename: "fridge_temperature.jpg",
                uploadedBy: "TNT-107",
                uploadedAt: "2025-05-05T07:50:00Z"
            }
        ],
        comments: [
            {
                id: "CMT-010",
                text: "We'll send a technician today to check your refrigerator.",
                author: "Admin",
                authorRole: "Property Manager",
                timestamp: "2025-05-05T08:30:00Z",
                isInternal: false
            },
            {
                id: "CMT-011",
                text: "This unit is only 2 years old, should be under warranty. Check the documentation.",
                author: "Sarah Manager",
                authorRole: "Property Manager",
                timestamp: "2025-05-05T09:15:00Z",
                isInternal: true
            }
        ]
    }
];

// Mock data for staff members
export const mockStaff = [
    {
        id: "STAFF-001",
        name: "Sarah Manager",
        role: "Property Manager",
        email: "sarah.m@example.com",
        phone: "+1111222333"
    },
    {
        id: "STAFF-002",
        name: "Mike Technician",
        role: "Maintenance",
        email: "mike.t@example.com",
        phone: "+1222333444"
    },
    {
        id: "STAFF-003",
        name: "Tom Plumber",
        role: "Contractor",
        email: "tom.p@example.com",
        phone: "+1333444555"
    },
    {
        id: "STAFF-004",
        name: "Carlos Carpenter",
        role: "Maintenance",
        email: "carlos.c@example.com",
        phone: "+1444555666"
    },
    {
        id: "STAFF-005",
        name: "Elena Technician",
        role: "Maintenance",
        email: "elena.t@example.com",
        phone: "+1555666777"
    }
];

// Status color mapping
export const statusColors = {
    OPEN: {
        bg: '#FEF3C7',
        color: '#D97706',
        icon: 'AlertTriangle',
        backgroundColor: '#FEF3C7'
    },
    'IN PROGRESS': {
        bg: '#DBEAFE',
        color: '#3B82F6',
        icon: 'Clock',
        backgroundColor: '#DBEAFE'
    },
    SCHEDULED: {
        bg: '#E0E7FF',
        color: '#6366F1',
        icon: 'Calendar',
        backgroundColor: '#E0E7FF'
    },
    RESOLVED: {
        bg: '#D1FAE5',
        color: '#10B981',
        icon: 'CheckCircle',
        backgroundColor: '#D1FAE5'
    },
    CLOSED: {
        bg: '#F3F4F6',
        color: '#6B7280',
        icon: 'XCircle',
        backgroundColor: '#F3F4F6'
    }
};

// Default status
export const defaultStatus = {
    bg: '#F3F4F6',
    color: '#6B7280',
    icon: 'AlertTriangle',
    backgroundColor: '#F3F4F6'
};

// Priority color mapping
export const priorityColors = {
    High: {bg: '#FEE2E2', color: '#EF4444'},
    Medium: {bg: '#FEF3C7', color: '#F59E0B'},
    Low: {bg: '#D1FAE5', color: '#10B981'}
};

// Default priority
export const defaultPriority = {bg: '#F3F4F6', color: '#6B7280'};

// Mock analytics data
export const mockAnalyticsData = {
    ticketTrend: [
        { name: 'Jan', tickets: 12 },
        { name: 'Feb', tickets: 19 },
        { name: 'Mar', tickets: 15 },
        { name: 'Apr', tickets: 22 },
        { name: 'May', tickets: 17 }
    ],
    resolutionTime: [
        { name: 'Jan', days: 3.2 },
        { name: 'Feb', days: 2.8 },
        { name: 'Mar', days: 2.5 },
        { name: 'Apr', days: 2.2 },
        { name: 'May', days: 1.9 }
    ],
    categoryDistribution: {
        Plumbing: 8,
        HVAC: 6,
        Electrical: 5,
        Carpentry: 4,
        Appliance: 7,
        Security: 3,
        'Noise Complaint': 2,
        Other: 1
    },
    propertyComparison: [
        { property: "Sunshine Apartments", tickets: 24, resolutionTime: 2.1 },
        { property: "Parkview Residences", tickets: 18, resolutionTime: 2.4 },
        { property: "Riverfront Condos", tickets: 16, resolutionTime: 1.8 },
        { property: "Highland Towers", tickets: 12, resolutionTime: 2.7 }
    ]
};